import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Obstacle } from '@thive/fddm-types';
import { Stack } from '@mui/system';

import { Accordion } from '@common/components/Accordion';

import { Thickness } from './obstacle/Thickness';
import WallMaterial from './obstacle/WallMaterial';
import Height from './obstacle/Height';
import { UserPreferenceName } from '@/modules/userPreferences';
import {
  FIELDS_PADDING_BOTTOM,
  FIELDS_SPACING,
  PANEL_ACCORDION_SX,
} from '@/modules/common/constants/propertyPanel';

interface Props {
  selectedWalls: Obstacle[];
}

function WallParametersComponent({ selectedWalls }: Props) {
  const { t } = useTranslation();
  const title =
    selectedWalls.length === 1
      ? t<string>('interface:properties.wall.title', 'Wall')
      : t<string>('interface:properties.wall.title_plural', `Walls (${selectedWalls.length})`, {
          amount: selectedWalls.length,
        });

  return (
    <Accordion
      persistId={UserPreferenceName.ACCORDION_PROPERTY_PANEL_WALL}
      title={title}
      unmountOnExit
      sx={PANEL_ACCORDION_SX}
    >
      <Stack direction='column' spacing={FIELDS_SPACING} pb={FIELDS_PADDING_BOTTOM}>
        <Thickness selectedWalls={selectedWalls} />
        <WallMaterial selectedWalls={selectedWalls} />
        <Height selectedObstacles={selectedWalls} />
      </Stack>
    </Accordion>
  );
}

export const WallParameters = memo(WallParametersComponent);
